// Filters
import {Date} from './Date'
import {TextHumanize} from './TextHumanize'

// Utils
import {registerFilters} from '../utils/registerFilters'

registerFilters({
    Date,
    TextHumanize,
})
